import {
	createSSRApp
} from "vue";
import store from './store/index'
import uView from 'vk-uview-ui';

import App from "./App.vue";
export function createApp() {
	const app = createSSRApp(App);
	app.use(store);
	app.use(uView);
	return {
		app,
	};
}
